import store from "@/store";
import config from "@/config";
import * as logs from "@/plugins/logs.js";
import * as broadcast from "@/plugins/broadcastChannel";
import axiosInstance from "@/plugins/axios.js";
import { getLogoutRedirectUri } from "@/msalConfig";

export function getReqConfig(token, provider, tenant, additionalHeaders) {
  let headers = {};

  if (provider) {
    headers["auth-provider"] = provider;
  }
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  if (tenant) {
    headers["tenant-id"] = tenant;
  }

  let config = {
    headers: headers,
  };
  if (additionalHeaders != null) {
    config.headers = { ...additionalHeaders, ...config.headers };
  }

  return config;
}

export function getPermissions(accessToken) {
  const url = `${config.apiUrl}/users/me/permissions`;

  const headers = getReqConfig(accessToken);

  return axiosInstance
    .get(url, headers)
    .then((res) => {
      return setupStoreAuth(res.data);
    })
    .catch((err) => {
      console.log("Something went wrong with authentication.");
      logs.error({
        msg: "Something went wrong with authentication.",
        obj: err,
        arr: [
          "If the issue is cross origin, then it is most likely that the local API Service is not running",
        ],
      });
      throw err; // Re-throw the error to be caught by the router guard
    });
}

export function setupStoreAuth(user) {
  return Promise.all([
    store.dispatch("auth/setPermissions", user),
    store.dispatch("accounts/setAccounts", user.accountPermissions),
  ]).then(() => {
    localStorage.setItem("hasLoadedPermissions", JSON.stringify(true));
    store.state.auth.hasLoadedPermissions = true;
    return user;
  });
}

export function isSuperAdminOrTreasurerForAccount(accountId) {
  const state = store.state.auth;
  return (
    (state.treasurerAccounts &&
      state.treasurerAccounts.includes(parseInt(accountId))) ||
    state.isSuperAdmin
  );
}

export function isTreasurerForAccount(accountId) {
  const state = store.state.auth;
  return (
    state.treasurerAccounts &&
    state.treasurerAccounts.includes(parseInt(accountId)) &&
    !state.isSuperAdmin
  );
}

export function isConsultantOrFundraiserForAccount(accountId) {
  const state = store.state.auth;
  return (
    state.consultantFundraiserAccounts &&
    state.consultantFundraiserAccounts.includes(parseInt(accountId))
  );
}

export function logout() {
  console.log("logging out");
  store.dispatch("auth/logout");
  broadcast.sendLogoutSignal();
  window.location = getLogoutRedirectUri();
}
